/**
 * Converts an ISO 3166-1 alpha-2 code (e.g. "SI") into its Unicode flag
 * emoji (🇸🇮) by mapping each letter to its "regional indicator symbol"
 * code point (U+1F1E6 = 'A' ... U+1F1FF = 'Z') - the standard technique for
 * rendering country flags from just two ASCII letters, no image asset
 * needed. Falls back to the plain code (uppercased) if it isn't exactly two
 * ASCII letters - should never happen for a row from the `countries` table,
 * but this keeps a malformed value from throwing instead of just looking a
 * little odd (used only for the share-text builder in PurchasePanel).
 */
export function flagEmoji(alpha2: string): string {
  const code = alpha2.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return code;
  const codePoints = [...code].map((letter) => 0x1f1e6 + (letter.charCodeAt(0) - 65));
  return String.fromCodePoint(...codePoints);
}
